import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native'

import {
  DownloadButton,
  downloadReport
} from '../../elements/ReportDownload';

import { cardStyles as styles } from './index';

const SalesAndExpenseReport = ({ data }) => {
  const [sellerId, setSellerId] = useState();
  const [soldStatus, setSoldStatus] = useState();
  const [saleId, setSaleId] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'sales-and-expense-report',
      params: { 'sellerId': sellerId, status: soldStatus,'sale-id': saleId }
    }) }
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Sales and Expense Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <select
        style={styles.select}
        onChange={(e) => setSellerId(e.target.value)}>
        <option key="seller-nil" value="">Select Seller</option>
        {data.sellers?.map(seller => (
          <option key={seller.id} value={seller.id}>
            {seller.fullDisplayName}
          </option>
        ))}
      </select>
      <Text style={styles.label}>Sale:</Text>
      <select style={styles.select} onChange={(e) => setSaleId(e.target.value)}>
        <option key="sale-nil" value="">Select Sale</option>
        {data.sales?.map(sale => (
          <option key={sale.id} value={sale.id}>
            {sale.name}
          </option>
        ))}
      </select>
      <Text style={styles.label}>Sold Status:</Text>
      <select style={styles.select} onChange={(e) => setSoldStatus(e.target.value)}>
        <option key="status-all">All</option>
        <option key="status-sold">Sold</option>
        <option key="status-notSold">Not Sold</option>
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default SalesAndExpenseReport;
